(function () {
    "use strict";

    angular
        .module("app.productDetail")
        .controller("ProductDetailController", ProductDetailController);

    ProductDetailController.$inject = [
        "$scope",
        "$rootScope",
        "ProductDetailService",
        "GeneralService",
        "$cookies",
        "$uibModal",
        "SharedData",
        "$sce",
        "ProductService",
        "CartService",
    ];

    function ProductDetailController(
        $scope,
        $rootScope,
        ProductDetailService,
        GeneralService,
        $cookies,
        $uibModal,
        SharedData,
        $sce,
        ProductService,
        CartService
    ) {
        /* jshint validthis:true */
        var vm = this;
        var lastProductView = false;
        vm.productFeatures = [];
        vm.selectedVariant = {};
        vm.SharedData = SharedData;
        vm.productMediaListForSlider = [];
        vm.productMediaListForTechnical = [];
        vm.variantProduct = [];
        vm.relatedProducts=[];

        function activate() {}

        window.addEventListener(
            "hashchange",
            function () {
                $scope.$apply();
            },
            false
        );

        vm.getBankList = function () {
            GeneralService.GetBanks({
                PageSize: -1,
            }).then(function (data) {
                vm.bankList = data.data;
                vm.commericalBankList = vm.bankList.filter(function (item) {
                    var installment = item.Installment.find(function (subitem) {
                        return (
                            subitem.Commercial == true &&
                            item.ShowInstallments == true
                        );
                    });
                    return installment != null;
                });
                vm.nonCommericalBankList = vm.bankList.filter(function (item) {
                    var installment = item.Installment.find(function (subitem) {
                        return (
                            subitem.Commercial == false &&
                            item.ShowInstallments == true
                        );
                    });
                    return installment != null;
                });
            });
        };

        $scope.$watch(
            function () {
                return location.href;
            },
            function (value) {
                if (value) {
                    var hash = decodeURI(value.split("#")[1]);
                    if (hash != "undefined") {
                        vm.selectedVariant = vm.productFeatures.find(function (
                            item
                        ) {
                            if (!lastProductView) {
                                AddLastViewProductList(item.ProductCode);
                                lastProductView = true;
                            }
                            return item.Code == hash;
                        });
                        if (
                            vm.galleryId != undefined &&
                            (vm.entity != null || vm.mainProduct != null)
                        ) {
                            vm.getGalleryListLoad(vm.galleryId);
                        }
                    }
                }
            }
        );

        $scope.$watchCollection(
            "vm.selectedProductOption",
            function (newValue, oldValue) {
                if (newValue) {
                    vm.changeProduct(newValue);
                }
            },
            true
        );

        vm.changeProduct = function (selectedProductOption) {
            selectedProductOption = selectedProductOption
                ? selectedProductOption
                : vm.selectedProductOption;
            var result = Object.keys(selectedProductOption).map((key) => [
                key,
                selectedProductOption[key],
            ]);
            var optionValueList = result.map(function (innerArray) {
                return innerArray[1];
            });
            vm.getVariantProduct(optionValueList);
        };

        vm.activateProduct = function (product) {
            if (product) {
                vm.entity = product;
                vm.getProductMediaList();
                vm.getGalleryListLoad(vm.galleryId);
                var url = location.href.contains("#")
                    ? location.href.split("#")[0]
                    : location.href;
                history.replaceState(
                    undefined,
                    undefined,
                    url + "#" + (vm.entity.Code || "")
                );
            }
        };

        vm.activateFirstVariant = function () {
            var hash = window.location.hash;
            if (hash) {
                var includeProperty = vm.getIncludeProperty();
                includeProperty.push("ProductVariantValue");
                hash = hash.split("#")[1];
                ProductDetailService.getProductWithCode({
                    Code: hash,
                    IncludeProperties: includeProperty,
                }).then(function (data) {
                    vm.activateProduct(data.data);
                    var selectedOptionValueId =
                        data.data.ProductVariantValue.map(function (item) {
                            return item.ProductOptionValueId;
                        });
                    var temp = [];
                    var resultOptionGroupList = Object.keys(
                        vm.optionGroupList
                    ).map((key) => [key, vm.optionGroupList[key]]);
                    $(resultOptionGroupList).each(function (i, item) {
                        $(item[1]).each(function (y, subItem) {
                            if (selectedOptionValueId.includes(subItem.Id)) {
                                temp[item[0]] = subItem.Id;
                            }
                        });
                    });
                    var result = Object.keys(temp).map((key) => [
                        key,
                        temp[key],
                    ]);
                    var optionValueList = result.map(function (innerArray) {
                        return innerArray[1];
                    });
                    var keyList = optionValueList.join(",");
                    vm.variantProduct[keyList] = data.data;
                    vm.selectedProductOption = temp;
                });
            } else {
                var temp = [];
                var result = Object.keys(vm.optionGroupList).map((key) => [
                    key,
                    vm.optionGroupList[key],
                ]);
                $(result).each(function (i, item) {
                    $(item[1]).each(function (y, subItem) {
                        if (subItem.Default) {
                            temp[item[0]] = subItem.Id;
                        }
                    });
                    if (!temp[i]) {
                        temp[item[0]] = item[1][0].Id;
                    }
                });
                vm.selectedProductOption = temp;
            }
        };

        vm.getVariantProduct = function (optionValueList) {
            var includeProperty = vm.getIncludeProperty();
            var keyList = optionValueList.join(",");
            if (vm.variantProduct[keyList]) {
                vm.activateProduct(vm.variantProduct[keyList]);
            } else {
                ProductDetailService.getVariantProduct({
                    ProductId: vm.mainProduct.Id,
                    SelectedIds: optionValueList,
                    IncludeProperties: includeProperty,
                }).then(function (data) {
                    vm.variantProduct[keyList] = data.data;
                    vm.activateProduct(data.data);
                });
            }
        };

        vm.getIncludeProperty = function () {
            var includeProperty = [];
            if (vm.activateBrand) {
                includeProperty.push("ProductBrand.Media");
            }
            if (vm.activateTag) {
                includeProperty.push("ProductTag.Tag.Media");
            }
            if (vm.activateDescription) {
                includeProperty.push("Detail");
            }
            if (vm.activateOptions) {
                includeProperty.push(
                    "ProductOptionValue.Option.TopOption",
                    "ProductOptionValue.OptionValue"
                );
            }
            return includeProperty;
        };

        vm.getGalleryListLoad = function (GalleryId) {
            var owl = $(".gallery-mazaka-slider");
            owl.owlCarousel();          
            vm.galleryId = GalleryId;
            vm.galleryMediaList = [];
            setTimeout(function () {
                if (vm.entity != null || vm.mainProduct != null) {
                    var filter = {
                        GalleryId: GalleryId,
                        OrProductId: vm.entity
                            ? vm.entity.Id
                            : vm.mainProduct.Id,
                        OrCategoryId: vm.entity
                            ? vm.entity.MainCategoryId
                            : vm.mainProduct.MainCategoryId,
                        IsImage: true,
                    };
                    GeneralService.getGalleryMediaList(filter).then(function (
                        data
                    ) {
                        owl.trigger("destroy.owl.carousel");
                        vm.galleryMediaList = data.data;
                        setTimeout(function () {    
                            initSlider(".gallery-mazaka-slider");
                        }, 1000);
                    });
                }
                else{
                    console.log("init adımına girmedi.");
                }
            }, 1000);
        };

        vm.OpenPhotosModal = function (productId) {
            ProductDetailService.getProduct(productId).then(function (data) {
                vm.productImages = data.data.ProductMedia;
                setTimeout(function () {
                    $(
                        ".group-product-images .group-product-image"
                    ).magnificPopup({
                        type: "image",
                        gallery: {
                            enabled: true,
                        },
                    });
                    $(
                        $(".group-product-images .group-product-image")[0]
                    ).click();
                }, 100);
            });
        };

        function getCookieByName(name) {
            return $cookies.get(name);
        }

        function setCookie(name, value) {
            $cookies.put(name, value);
        }

        function AddLastViewProductList(value) {
            const unique = (value, index, self) => {
                return self.indexOf(value) === index;
            };
            var lastviewProduct = getCookieByName("LastViewProduct");

            var lastViewProductList = [];
            if (lastviewProduct)
                lastViewProductList = lastviewProduct.split(",");
            if (lastViewProductList) {
                if (!lastViewProductList.find((x) => x == value)) {
                    if (lastViewProductList.length != 5) {
                        lastViewProductList.unshift(value);
                    } else {
                        lastViewProductList.shift();
                        lastViewProductList.unshift(value);
                    }
                }
            }
            lastViewProductList = lastViewProductList.filter(unique);
            setCookie("LastViewProduct", lastViewProductList);
        }

        vm.getTrustUrl = function (url) {
            return $sce.trustAsResourceUrl(url);
        };

        vm.activateForSlider = function () {
            setTimeout(() => {
                if (typeof activateForSlider === "function") {
                    if(window.DetailProductSlider){
                        window.DetailProductSlider.destroy();
                    }
                    activateForSlider($(".product-slider-detail"));
                }
                if (typeof initSwiper === "function") {
                    initSwiper();
                }
            }, 500);
        };

        vm.activateForTechnical = function () {
            setTimeout(() => {
                if (typeof activateForTechnical === "function") {
                    activateForTechnical(".technical-slider__slider");
                }
            }, 500);
        };

        vm.getDefaultPrice = function (product) {
            var defaultPrice = product.PriceWithDiscount;
            if (product.Currency.Default == false) {
                if (product.Price != product.PriceWithDiscount) {
                    defaultPrice =
                        product.PriceWithDiscount *
                        product.DefaultQuantity *
                        product.Currency.Rate;
                } else {
                    defaultPrice = productPrice * product.Currency.Rate;
                }
            }
            return defaultPrice;
        };

        vm.getDefaultPriceWithDiscount = function (product) {
            var defaultNonDiscountPrice = product.Price;
            if (product.Currency.Default == false) {
                if (product.Price != product.PriceWithDiscount) {
                    defaultNonDiscountPrice =
                        product.Price *
                        product.DefaultQuantity *
                        product.Currency.Rate;
                }
            }
            return defaultNonDiscountPrice;
        };

        vm.getDefaultTierPrice = function (tierPrice, product) {
            var defaultTierPrice = tierPrice;
            if (product.Currency.Default == false) {
                defaultTierPrice = tierPrice * product.Currency.Rate;
            }
            return defaultTierPrice;
        };

        vm.getEarnTierPrice = function (tierPrice, product) {
            var earnPerProduct =
                product.PriceWithDiscount * product.DefaultQuantiy -
                tierPrice.Price;
            var totalEarn = earnPerProduct * tierPrice.Quantity;
            return totalEarn;
        };

        vm.getTierPriceListWithRole = function (roleId) {
            return vm.entity.TierPrice.some(
                (k) => !k.RoleId || k.RoleId === roleId
            );
        };

        vm.getProductMediaList = function () {
            if (
                !vm.activateMediaListForSlider &&
                !vm.activateMediaListForTechnical
            ) {
                return false;
            }
            vm.mediaListForSlider = [];
            vm.mediaListForTechnical = [];
            if (vm.productMediaListForSlider[vm.entity.Id]) {
                vm.mediaListForSlider =
                    vm.productMediaListForSlider[vm.entity.Id];
                vm.activateForSlider();
            } else if (vm.productMediaListForTechnical[vm.entity.Id]) {
                vm.mediaListForTechnical =
                    vm.productMediaListForTechnical[vm.entity.Id];
                vm.activateForTechnical();
            } else {
                ProductDetailService.getProductMediaList(vm.entity.Id).then(
                    function (data) {
                        vm.productMediaListForSlider[vm.entity.Id] =
                            data.data.filter(function (element) {
                                return element.ShowSlider == true;
                            });
                        vm.mediaListForSlider =
                            vm.productMediaListForSlider[vm.entity.Id];
                        vm.activateForSlider();
                        vm.productMediaListForTechnical[vm.entity.Id] =
                            data.data.filter(function (element) {
                                return element.IsTechnical == true;
                            });
                        vm.mediaListForTechnical =
                            vm.productMediaListForTechnical[vm.entity.Id];
                        vm.activateForTechnical();
                    }
                );
            }
        };

        vm.getMainProduct = function () {
            var includeProperty = vm.getIncludeProperty();
            ProductDetailService.getMainProduct({
                ProductId: vm.mainProductId,
                IncludeProperties: includeProperty,
            }).then(function (data) {
                vm.mainProduct = data.data;
                if (vm.mainProduct.IsMainGroupProduct) {
                    ProductDetailService.getGroupProductList(
                        vm.mainProductId
                    ).then(function (data) {
                        vm.mainProduct.GroupProduct = data.data;
                        vm.entity = vm.mainProduct;
                        vm.loadEntity();
                    });
                } else if (vm.mainProduct.IsMainVariantProduct) {
                    ProductDetailService.getVariantProductList(
                        vm.mainProductId
                    ).then(function (data) {
                        vm.entity = vm.mainProduct;
                        vm.loadEntity();
                        vm.mainProduct.ProductOptionValue = data.data;

                        var filteredSpesificValues =
                            vm.mainProduct.ProductOptionValue.filter(function (
                                k
                            ) {
                                return k.IsSpecific;
                            }).sort(function (a, b) {
                                return (
                                    a.Option.DisplayOrder -
                                    b.Option.DisplayOrder
                                );
                            });

                        var filteredNonSpesificValues =
                            vm.mainProduct.ProductOptionValue.filter(function (
                                k
                            ) {
                                return !k.IsSpecific;
                            }).sort(function (a, b) {
                                return (
                                    a.Option.DisplayOrder -
                                    b.Option.DisplayOrder
                                );
                            });

                        var groupedValues = {};
                        filteredNonSpesificValues.forEach(function (k) {
                            if (!groupedValues[k.OptionId]) {
                                groupedValues[k.OptionId] = [];
                            }
                            groupedValues[k.OptionId].push(k);
                        });
                        vm.optionGroupList = groupedValues;

                        var groupedValuesTopOptionForSpesific = {};
                        filteredSpesificValues.forEach(function (k) {
                            if (
                                !groupedValuesTopOptionForSpesific[
                                    k.Option.TopOption
                                ]
                            ) {
                                groupedValuesTopOptionForSpesific[
                                    k.Option.TopOption
                                ] = [];
                            }
                            groupedValuesTopOptionForSpesific[
                                k.Option.TopOption
                            ].push(k);
                        });
                        vm.optionGroupSpesificListForTopOption =
                            groupedValuesTopOptionForSpesific;

                        vm.mainProductNonSpesific =
                            vm.mainProduct.ProductOptionValue.some(function (
                                k
                            ) {
                                return !k.IsSpecific;
                            });
                        vm.activateFirstVariant();
                    });
                } else {
                    vm.entity = vm.mainProduct;
                    vm.loadEntity();
                }
            });
        };

        vm.loadEntity = function () {
            vm.getProductMediaList();
            if (vm.activateTag) {
                vm.productTagFilter = vm.entity.ProductTag.filter(function (
                    element
                ) {
                    return element.Tag.Active == true;
                });
                vm.productTagList = vm.entity.ProductTag.filter(function (
                    element
                ) {
                    return (
                        element.Tag.Active == true &&
                        element.Tag.ShowinProductDetail == true
                    );
                });
            }
        };

        vm.getLastViewedProductList = function () {
            ProductDetailService.getLastViewedProductList().then(function (
                data
            ) {
                vm.lastViewedProductList = data.data.Data;
                setTimeout(() => {
                    initSlider(".last-viewed-products-part__slider");
                }, 500);
            });
        };

        vm.getRelatedProducts = function (
            categoryId,
            productId,
            productQuantity,
            InStock
        ) {
            ProductDetailService.getRelatedProducts({
                CategoryId: categoryId,
                ProductId: productId,
                ProductQuantity: productQuantity,
                InStock: InStock,
            }).then(function (data) {
                vm.relatedProducts = data.data;
                vm.checkFavorite(vm.relatedProducts)
                setTimeout(() => {
                    initSlider(".product-related-products-part__slider");
                }, 500);
            });
        };

        vm.checkFavorite = function (productList) {
            for (let index = 0; index < productList.length; index++) {
                if (vm.IsInFavorite(productList[index])) {
                    productList[index].IsInFavorite = true;
                } else {
                    productList[index].IsInFavorite = false;
                }
            }
        };

        vm.IsInFavorite = function (product) {
            var editFavCartProduct = vm.getFavoriteProducts(product);
            if (editFavCartProduct.length > 0) {
                return true;
            }
            return false;
        };

        vm.DeleteFavoriteCartProduct = function (product) {
            var editFavCartProduct = vm.getFavoriteProducts(product);
            if (editFavCartProduct.length > 0) {
                CartService.Delete(editFavCartProduct[0]).then(function () {
                    CartService.getCart({ CartType: "Favorite" }).then(
                        function (_cart) {
                            $rootScope.favoriteCart = _cart;
                            vm.checkFavorite(vm.relatedProducts);
                        }
                    );
                });
            }
        };

        vm.AddFavoriteCartProduct = function (product) {
            var editFavCartProduct = vm.getFavoriteProducts(product);
            if (editFavCartProduct.length == 0) {
                var params = {
                    productID: product.Id,
                    CartType: "Favorite",
                };
                CartService.InsertWithParams(params).then(function () {
                    CartService.getCart({ CartType: "Favorite" }).then(
                        function (_cart) {
                            $rootScope.favoriteCart = _cart;
                            vm.checkFavorite(vm.relatedProducts);
                        }
                    );
                });
            }
        };

        vm.getFavoriteProducts = function (product) {
            if ($rootScope.favoriteCart) {
                var favoriteProductList = $rootScope.favoriteCart.CartProduct;
                var filterFavorites = favoriteProductList.filter(function (
                    item
                ) {
                    return item.ProductId.includes(product.Id);
                });
                return filterFavorites;
            } else {
                return [];
            }
        };


        vm.getRelatedProductList = function (productId, relatedProductTypeId) {
            ProductDetailService.getRelatedProductList({
                ProductId: productId,
                RelatedProductTypeId: relatedProductTypeId,
            }).then(function (data) {
                vm.relatedProductList = data.data;
                setTimeout(() => {
                    initSlider(".product-related-products-part-list");
                }, 500);
            });
        };

        vm.getProductReviewList = function (productId) {
            ProductDetailService.getProductReviewList(productId).then(function (
                data
            ) {
                vm.productReviewList = data.data;
                vm.reviewAvarageValue = 0;
                
                if (vm.productReviewList.length > 0) {
                    var sum = 0;
                    var count = vm.productReviewList.length;

                    for (var i = 0; i < count; i++) {
                        sum += vm.productReviewList[i].Rating;
                    }

                    var average = sum / count;
                    vm.reviewAvarageValue = average.toFixed(2);

                    setTimeout(function(){
                        $(".listRate").each(function (i, obj) {
                            var ratingValue = obj.attributes["data-value"].value;
                            if (ratingValue !== null) {
                                $(obj).rateYo({
                                    starWidth: "20px",
                                    rating: ratingValue,
                                    readOnly: true,
                                });
                            }
                        });
                    },100)
                }
            });
        };

        vm.getValueSettings = function (settings, variable) {
            var value = JSON.parse(settings || "{}");
            if (!value) {
                return null;
            }
            return value[variable];
        };

        vm.getLabel = function (optionId, productOptionValueId) {
            var getLabel = vm.optionGroupList[optionId].find(function (item) {
                return item.Id == productOptionValueId;
            });
            if (!getLabel) {
                return "";
            }
            return getLabel.OptionValue;
        };

        vm.getAllSubProduct = function () {
            var includeProperty = vm.getIncludeProperty();
            includeProperty.push("Currency");
            includeProperty.push("TierPrice");
            includeProperty.push("Discount");
            includeProperty.push("ProductMedia.Media");
            includeProperty.push("ProductVariantValue");
            var params = {
                BaseProductId: vm.mainProductId,
                IncludeProperties: includeProperty,
                PageSize: -1,
            };
            ProductService.filter(params).then(function (data) {
                vm.mainProduct.ProductVariant = data.Data;
                $(data.Data).each(function (i, item) {
                    vm.productMediaListForSlider[item.Id] = item.ProductMedia;
                    var optionValueList = item.ProductVariantValue.map(
                        (x) => x.ProductOptionValueId
                    );
                    var keyList = optionValueList.join(",");
                    vm.variantProduct[keyList] = item;
                });
            });
        };

        vm.getSubProductWithOptionValueId = function (OptionValueId) {
            return vm.mainProduct.ProductVariant.find(function (item) {
                return item.ProductOptionValue.some(function (subitem) {
                    return subitem.OptionValueId == OptionValueId;
                });
            });
        };

        activate();
    }
})();
